// extracted by mini-css-extract-plugin
module.exports = {"multipleColumnContent":"section_multipleColumnContent__KJNd_","twoUpContent":"section_twoUpContent__PYFF0","fullBleedHeroImage":"section_fullBleedHeroImage__3JtOP"};